/* eslint-disable no-empty-pattern */
/* eslint-disable no-shadow */
import {
  GetterTree, MutationTree, ActionTree, Module
} from 'vuex';
import ValuationRequest from '@/models/valuation/ValuationRequest';
import { vehicleValuationService } from '@/services/VehicleValuationLookupService';
import ValuationResponse from '@/models/valuation/ValuationResponse';
import ValuationResultType from '@/enums/valuation/ValuationResultType';
import Valuation from '@/models/valuation/Valuation';
import ExtraData from '@/models/ExtraData';
import ValuationVehicle from '@/models/valuation/ValuationVehicle';
import PricingProviderType from '@/enums/valuation/PricingProviderType';
import VehicleValuationState from '../states/vehicle-valuation-state';
import IRootState from '../states/interfaces/index.d';
import IVehicleValuationState from '../states/interfaces/vehicle-valuation-state.d';

export const state: IVehicleValuationState = new VehicleValuationState();

export const getters: GetterTree<IVehicleValuationState, IRootState> = {
  valuationRequest: (state): ValuationRequest => state.valuationRequest,
  vehicleValuation: (state): Valuation => state.valuationResponse.result,
  valuationResultType: (state): ValuationResultType => state.valuationResponse.resultType,
  manufacturerImageSlug: (state): string => {
    const vehicleName: string = state.valuationResponse.result.vehicle.name.toLowerCase();
    if (vehicleName.includes('mercedes')) {
      return 'mercedesbenz';
    } if (vehicleName.includes('aston')) {
      return 'astonmartin';
    } if (vehicleName.includes('land')) {
      return 'landrover';
    } if (vehicleName.includes('alfa')) {
      return 'alfaromeo';
    }

    const manufacturerName = vehicleName.split(' ');
    return manufacturerName[0];
  },
  isManualVehicle: (state): boolean => state.isManualVehicle,
  isRegistrationLookupDataSet: (state, getters, rootState): boolean => {
    const { overlayStep } = rootState.enquiryModule;
    const valuation = state.valuationResponse.result;
    return (overlayStep === 1
      && valuation.registration !== ''
      && valuation.mileage > 0
      && valuation.vehicle.name !== ''
      && valuation.vehicle.plateYear !== null)
    || (overlayStep === 3
      && valuation.vehicle.name !== ''
      && valuation.vehicle.plateYear !== null)
    || overlayStep === 2;
  },
  registrationSelectionKey: (state) => {
    const { valuationRequest } = state;
    const valuation = state.valuationResponse.result;
    let key = '';
    if (valuationRequest.registration !== '' && valuationRequest.registration.length > 0) {
      key += valuationRequest.registration;
    }

    if (valuationRequest.mileage > 0) {
      key += valuationRequest.mileage.toString();
    }

    if (valuation.vehicle.name !== '' && valuation.vehicle.name.length > 0) {
      key += valuation.vehicle.name;
    }

    if (valuation.vehicle.plateYear !== null) {
      key += valuation.vehicle.plateYear;
    }

    return key;
  },
  moduleKey: (state): string => state.moduleKey
};

export const mutations: MutationTree<IVehicleValuationState> = {
  setVehicleValuationRequest: (state: IVehicleValuationState, valuationRequest: ValuationRequest) => {
    state.valuationRequest = valuationRequest;
  },
  setVehicleValuationResponse: (state: IVehicleValuationState, valuationResponse: ValuationResponse) => {
    state.valuationResponse = valuationResponse;
  },
  setPlateYear: (state: IVehicleValuationState, plateYear: string | null) => {
    state.valuationResponse.result.vehicle.plateYear = plateYear;
  },
  setRegistration: (state: IVehicleValuationState, registration: string) => {
    state.valuationResponse.result.registration = registration;
  },
  setIsManualVehicle: (state: IVehicleValuationState, isManualVehicle: boolean) => {
    state.isManualVehicle = isManualVehicle;
  },
  setVehicleValuationData: (state: IVehicleValuationState, valuation: Valuation) => {
    state.valuationResponse.result = valuation;
  },
  setModuleKey: (state: IVehicleValuationState, moduleKey: string) => {
    state.moduleKey = moduleKey;
  },
  setResetValuationVehicle: (state: IVehicleValuationState, vehicle: ValuationVehicle) => {
    state.valuationResponse.result.vehicle = vehicle;
  }
};

export const actions: ActionTree<IVehicleValuationState, IRootState> = {
  retrieveVehicleValuationData({ commit, rootState, dispatch }, valuationRequest: ValuationRequest) {
    valuationRequest.vehicleType = rootState.initialSettingsModule.initialSettings.vehicleType;
    valuationRequest.vehiclePricingProviderType = rootState.initialSettingsModule.valuationInitialSettings.vehiclePricingProviderType;

    if (valuationRequest.vehicleType === 2) {
      return 0;
    }

    commit('setVehicleValuationRequest', valuationRequest);

    return new Promise((resolve) => {
      vehicleValuationService.getVehicleValuation(valuationRequest)
        .then((value: ValuationResponse) => {
          if (value.success && value.result !== null) {
            commit('setVehicleValuationResponse', value);
            dispatch('submitValuationExtraData', value.result);
          }

          resolve(value.resultType);
        });
    });
  },
  submitValuationExtraData({ commit, dispatch }, valuation: Valuation) {
    if (valuation.vehicle.name !== null && valuation.vehicle.name.length > 0) {
      const providerName = PricingProviderType[state.valuationRequest.vehiclePricingProviderType];
      const plateYear: string = valuation.vehicle.plateYear ? valuation.vehicle.plateYear : '';
      dispatch('enquiryModule/submitExtraData', new ExtraData('PartExchangeManualVehicle', `${state.isManualVehicle}`), { root: true });
      dispatch('enquiryModule/submitExtraData', new ExtraData('PartExchangeProvider', `${providerName}`), { root: true });
      dispatch('enquiryModule/submitExtraData', new ExtraData('PartExchangeRegistration', state.valuationRequest.registration), { root: true });
      dispatch('enquiryModule/submitExtraData', new ExtraData('PartExchangeMileage', `${state.valuationRequest.mileage}`), { root: true });
      dispatch('enquiryModule/submitExtraData', new ExtraData('PartExchangeVehicleName', valuation.vehicle.name), { root: true });
      dispatch('enquiryModule/submitExtraData', new ExtraData('PartExchangePlateYear', plateYear), { root: true });
      dispatch('enquiryModule/submitExtraData', new ExtraData('PartExchangeValue', `${valuation.privateClean}`), { root: true });
    }

    commit('setVehicleValuationData', valuation);
  },
  submitRemoveValuationExtraData({ dispatch }) {
    dispatch('enquiryModule/submitRemoveExtraData', 'PartExchangeManualVehicle', { root: true });
    dispatch('enquiryModule/submitRemoveExtraData', 'PartExchangeProvider', { root: true });
    dispatch('enquiryModule/submitRemoveExtraData', 'PartExchangeRegistration', { root: true });
    dispatch('enquiryModule/submitRemoveExtraData', 'PartExchangeMileage', { root: true });
    dispatch('enquiryModule/submitRemoveExtraData', 'PartExchangeVehicleName', { root: true });
    dispatch('enquiryModule/submitRemoveExtraData', 'PartExchangePlateYear', { root: true });
    dispatch('enquiryModule/submitRemoveExtraData', 'PartExchangeValue', { root: true });
  },
  submitPlateYear({ commit }, plateYear: string | null) {
    commit('setPlateYear', plateYear);
  },
  submitRegistration({ commit, state }) {
    commit('setRegistration', state.valuationRequest.registration);
  },
  submitIsManualVehicle({ commit }, isManualVehicle: boolean) {
    commit('setIsManualVehicle', isManualVehicle);
  },
  submitResetValuationData({ commit, dispatch }) {
    commit('setIsManualVehicle', false);
    commit('setVehicleValuationRequest', new ValuationRequest());
    commit('setVehicleValuationResponse', new ValuationResponse());
    commit('setModuleKey', '');
    dispatch('submitRemoveValuationExtraData');
  },
  submitResetValuationVehicle({ commit }) {
    commit('setResetValuationVehicle', new ValuationVehicle());
  },
  submitModuleKey({ commit }, moduleKey: string) {
    commit('setModuleKey', moduleKey);
  }
};

export const vehicleValuationModule: Module<IVehicleValuationState, IRootState> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
